<template lang="pug">
shListData(title="Niveles" resolver="tiers" keyData="tier" component="shTier")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Tiers',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/tier/Tiers.vue